<template>
  <div class="body">
    <!-- 配送单 直接装箱-->
    <baseBreadcrumb :page="$t('message.porder')" :menu="$t('message.directPacking')" />
    <!-- 筛选 -->
    <div class="search">
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="search">
          <!-- 全部 -->
          <el-tab-pane :label="$t('message.all')" name="全部"></el-tab-pane>
          <!-- 装箱中 -->
          <el-tab-pane :label="$t('message.thePacking')" name="0"></el-tab-pane>
          <!-- 已装箱 -->
          <el-tab-pane :label="$t('message.boxed')" name="1"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="operationContainer">
        <div class="leftContainer">
          <!-- 开始日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container"
              type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 180px">
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
              default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 180px">
            </el-date-picker>
          </div>
          <!--   /配送单号-->
          <div class="item">
            <el-input v-model="datas.porder_sn" :placeholder="$t('message.deliveryNoteNumber')" class="Container"
              onfocus="this.select()" />
          </div>
          <!--   /订单号-->
          <div class="item">
            <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" class="Container"
              onfocus="this.select()" />
          </div>
          <!-- 客户ID-->
          <div class="item">
            <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" class="Container"
              onfocus="this.select()" />
          </div>
          <!--人员范围-->
          <div class="item">
            <!--  人员范围-->
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <div class="item">
            <!--  全体人员-->
            <el-select v-model="datas.admin_id" :placeholder="$t('message.specificPersonnel')" filterable clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
              <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 业务 -->
          <div class="item">
            <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
              <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 配货员 -->
          <div class="item">
            <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <!--  搜索 -->
            <el-button type="primary" @click="search">
              {{ $t("message.search") }}
            </el-button>
            <!--  重置 -->
            <el-button @click="reset">{{ $t("message.reset") }}</el-button>
          </div>
        </div>
        <div class="rightContainer">
          <!-- 入普通仓库 -->
          <el-button type="primary" class="primary" @click="warehousing(2)" v-if="isAuth(266)">
            {{ $t("message.intoGeneralStorage") }}</el-button>
          <!-- 入长存仓库 -->
          <el-button type="primary" class="primary" @click="warehousing(3)" v-if="isAuth(267)">
            {{ $t("message.intoLongTermStorageWarehouse") }}
          </el-button>
          <!--  退回装箱中-->
          <el-button type="primary" class="dark" @click="toUnComplete">
            {{ $t("message.returnToContainer") }}
          </el-button>
          <!--  生成配送单 -->
          <el-button type="primary" @click="boxToPorder" v-if="isAuth(268)">
            {{ $t("message.generateDeliveryOrder") }}</el-button>
        </div>
      </div>
      <div class="operationContainer">
        <div class="leftContainer">
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="table">
      <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
        :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
        ref="multipleTable" @cell-click="labelSelection" size="mini" v-if="show">
        <el-table-column align="center" label="NO" prop="rowNumber" width="60">
        </el-table-column>
        <el-table-column width="45" align="center">
          <template slot="header" slot-scope="scope">
            <span style="cursor: pointer;" @click="allchecked"> {{ $t('message.allChecked') }}</span>
          </template>
          <template slot-scope="scope">
            <div style="padding: 20px 0;">
              <el-popover placement="right" title="合计" width="200" trigger="focus">
                <statistics :checkedList="selectList" />
                <el-checkbox v-model="scope.row.checked" @change="changeItem" slot="reference"></el-checkbox>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <!--  操作人员-->
        <el-table-column align="center" :label="$t('message.operator')" width="120">
          <template slot-scope="scope">
            <div class="text-left">
              <!-- 业务员 -->
              <p>
                {{ $t("message.salesman") }}：
                {{
                  scope.row.order.y_admin != null ? scope.row.order.y_admin.realname : ''
                }}
              </p>
              <!-- 配货员 -->
              <p>
                {{ $t("message.distributionMember") }}：{{
                  scope.row.order.p_admin != null ? scope.row.order.p_admin.realname : ''

                }}
              </p>
              <!-- 采购员 -->
              <p>
                {{ $t("message.buyer") }}：{{
                  scope.row.order.g_admin != null ? scope.row.order.g_admin.realname : ''
                }}
              </p>
            </div>
          </template>
        </el-table-column>
        <!--  订单号-->
        <el-table-column align="center" :label="$t('message.orderNumber')">
          <template slot-scope="scope">
            <router-link :to="'/orderPaymentDetail?order_sn=' + scope.row.order_sn" target="_blank">
              {{ scope.row.order_sn }}</router-link>
            <p>
              <router-link
                :to="'/user/basicInformation?userID=' + scope.row.order.user.id + '&encryption=' + $md5(scope.row.order.user.id + '')"
                target="_blank" style="color:#606266 ">
                {{ scope.row.order.user.realname }}
              </router-link>
            </p>
          </template>
        </el-table-column>
        <!--  箱子编号-->
        <el-table-column align="center" :label="$t('message.boxNo')" width="80">
          <template slot-scope="scope">
            <p>
              <router-link :to="`/boxDetail?id=${scope.row.id}&verification=${$md5(scope.row.id + '')}`"
                target="_blank">
                <el-button size="mini" type="success">{{ scope.row.box_no }}</el-button>
              </router-link>
            </p>
          </template>
        </el-table-column>
        <!--  装箱时间-->
        <el-table-column align="center" :label="$t('message.packingTime')" prop="created_at" width="76">
        </el-table-column>
        <!--  打包完成时间-->
        <el-table-column align="center" :label="$t('message.packagingCompletionTime')" prop="complete_at" width="76">
        </el-table-column>
        <!--  重量(kg)-->
        <el-table-column align="center" :label="$t('message.weight') + '(kg)'" width="80">
          <template slot-scope="scope">
            {{ scope.row.weight }}
          </template>
        </el-table-column>
        <!--  箱规(cm)-->
        <el-table-column align="center" :label="$t('message.boxGauge')" width="80">
          <template slot-scope="scope">
            {{ scope.row.c }}* {{ scope.row.k }}* {{ scope.row.g }}
          </template>
        </el-table-column>
        <!--  箱子状态-->
        <el-table-column align="center" :label="$t('message.stateOfTheBox')" width="80">
          <template slot-scope="scope">
            {{ scope.row.status_name }}
          </template>
        </el-table-column>
        <!--  当前订单状态-->
        <el-table-column align="center" :label="$t('message.currentOrderStatus')" prop="order.status_name">
        </el-table-column>
        <!--  未出货订单-->
        <el-table-column align="center" :label="$t('message.orderNotShipped')" width="80" prop="order_detail_count">
        </el-table-column>
        <!--  库位信息-->
        <el-table-column align="center" :label="$t('message.libraryLocationInformation')">
          <template slot-scope="scope">
            <!-- 入库 -->
            <p></p>
            <!-- 收费 普通 -->
            <p>：{{ scope.row.grid_number }}</p>
          </template>
        </el-table-column>
        <!--  客户订单备注-->
        <el-table-column align="center" :label="$t('message.customerOrderNotes')" prop="order.client_remark">
        </el-table-column>
        <!--  配货装箱备注-->
        <el-table-column align="center" :label="$t('message.notesOnPackingOfGoods')" prop="p_remark">
          <template slot-scope="scope">
            <el-input type="textarea" v-model="scope.row.p_remark" @blur="updatePRemark(scope.row, 'p')"
              :disabled="remarkData.remark_type != 5"></el-input>
          </template>
        </el-table-column>
        <!--  业务员装箱备注-->
        <el-table-column align="center" :label="$t('message.salesmanPackingNotes')" prop="y_remark">
          <template slot-scope="scope">
            <el-input type="textarea" v-model="scope.row.y_remark" @blur="updatePRemark(scope.row, 'y')"
              :disabled="remarkData.remark_type != 1"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paginationContainer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[50, 100, 200, 300, 500]" :page-size="datas.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 备注 -->
    <el-dialog :title="remarkTitle" :close-on-click-modal="false" :visible.sync="remarkDialogVisible" width="400px"
      center>
      <div class="content">
        <el-input type="textarea" :placeholder="remarkTitle" v-model="remarkData.value" show-word-limit>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="updateRemark">
          {{ $t("message.ok") }}</el-button>
      </span>
    </el-dialog>
    <!-- 合并配送单 -->
    <!-- <andSingle v-if="andSingleDialogVisible" /> -->
    <!-- 仓库 -->
    <warehouse v-if="warehouseDialogVisible" :shelf_type_set="shelf_type_set" :type="type" :boxIds="boxIds" />
  </div>
</template>

<script>
import warehouse from "@/components/common/warehouse";
import statistics from './statistics'
export default {
  components: {
    warehouse,
    statistics,
  },
  data() {
    return {
      datas: {
        order_sn: "",
        dateStart: "",
        dateEnd: "",
        user_id: "",
        status: "0",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 50,
      },
      orderPaymentList: [],
      orderStatusList: [],
      adminOrganization: [],
      total: 0,
      tableData: [],
      selectList: [],
      show: false,
      remarkDialogVisible: false, //订单备注
      remarkTitle: "", //备注标题
      remarkData: {
        porder_sn: "",
        remark_type: localStorage.getItem("japanUserRoleStatus"), //工种
        col: "",
        value: "",
      },
      userList: [],
      //   配送单合并
      andSingleDialogVisible: false,
      //仓库
      warehouseDialogVisible: false,
      shelf_type_set: [], //货架类型
      type: "",
      boxIds: [],
      checked: false,
    };
  },
  computed: {
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
    typeList() {
      return this.$store.state.typeList;
    },
  },
  created() {
    let status = this.$route.query.status
    if (status) {
      this.datas.status = status
    }
    this.boxList();
    // this.$api.roleApi.getAdminOrganization().then((res) => {
    //   this.adminOrganization = res.data;
    //   console.log(res);
    // });
  },
  methods: {
    boxList() {
      this.show = false;
      //   this.datas.status = this.status;
      this.$api.porderApi.boxList(this.datas).then((res) => {

        res.data.data.forEach(item => {
          item.checked = false
        })
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.show = true;
        console.log(res);
      });
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.boxList();
    },
    // 重置
    reset() {
      this.datas = {
        order_sn: "",
        dateStart: "",
        dateEnd: "",
        user_id: "",
        status: "",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 50,
        porder_sn: "",
        y_id: '',
        g_id: '',
        p_id: '',
      };
      this.$refs.cascader.orgId = [];
      this.boxList();
    },

    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.boxList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.boxList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    // 显示备注
    showRemark(item) {
      this.remarkData.porder_sn = item.porder_sn;
      if (this.remarkData.remark_type == 1) {
        this.remarkTitle = this.$t("message.serviceRemarks");
        this.remarkData.value = item.porder_remark.y_remark;
        this.remarkData.col = "y_remark";
      } else if (this.remarkData.remark_type == 2) {
        this.remarkTitle = this.$t("message.purchasingNotes");
        this.remarkData.value = item.porder_remark.g_remark;
        this.remarkData.col = "g_remark";
      } else if (this.remarkData.remark_type == 5) {
        this.remarkTitle = this.$t("message.distributionRemarks");
        this.remarkData.value = item.porder_remark.g_remark;
        this.remarkData.col = "p_remark";
      }
      this.remarkDialogVisible = true;
    },
    // 编辑备注
    updateRemark() {
      this.$api.porderApi.updateRemark(this.remarkData).then((res) => {
        if (res.code != 0) return this.$message.error(res.message);
        this.remarkDialogVisible = false;
        this.boxList();
      });
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
    //关联子单号
    associateASuborderNumber() {
      this.andSingleDialogVisible = true;
    },
    //配送单生成
    boxToPorder() {
      if (this.selectList == false)
        this.$message.error(this.$t("message.selectableOperational"));
      this.$confirm(
        this.$t("message.isGenerateDeliveryOrder"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            boxIds: [],
          };
          this.selectList.forEach((item) => {
            datas.boxIds.push(item.id);
          });
          this.$api.porderApi.boxToPorder(datas).then((res) => {

            let url = this.$router.resolve({
              name: "porderDetail",
              query: {

                porder_sn: res.data,
              },
            });

            window.open(url.href, "_blank");
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //入库 type 2 普通仓库 3 收费仓库
    warehousing(type) {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.boxIds = [];

      if (type == 2) {
        this.shelf_type_set = [1, 3];
      } else {
        this.shelf_type_set = [4];
      }
      this.type = type;
      this.selectList.forEach((item) => {
        this.boxIds.push(item.id);
      });
      this.warehouseDialogVisible = true;
    },
    //退回装箱中
    toUnComplete() {
      if (this.selectList == false)
        this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        ids: []
      }
      this.selectList.forEach(item => {
        datas.ids.push(item.id)
      })
      this.$api.inspectionApi.toUnComplete(datas).then(res => {
        this.$message.success(res.msg)
        this.boxList();
      })
    },
    // 单选
    changeItem() {
      this.selectList = []
      this.tableData.forEach(item => {
        if (item.checked) {
          this.selectList.push(item)
        }
      })

    },
    //全选
    allchecked() {
      this.checked = !this.checked
      this.selectList = []
      this.tableData.forEach(item => {
        item.checked = this.checked
        if (item.checked) {
          this.selectList.push(item)
        }
      })
    },
    // 备注
    updatePRemark(item, type) {
      let datas = {
        box_id: item.id,
      };
      if (type == 'p') {
        datas.p_remark = item.p_remark
        this.$api.inspectionApi.updatePRemark(datas);
      } else {
        datas.y_remark = item.y_remark
        this.$api.inspectionApi.updateYRemark(datas);

      }

    },
  },
};
</script>

<style lang='scss' scoped>
.search {
  /deep/.el-select {
    width: 217px;
  }

  /deep/.el-date-editor {
    width: 217px !important;
  }
}

.table {
  margin: 20px 0;
}

.item {
  margin-right: 20px;
  margin-bottom: 20px;
}

.operationContainer {
  display: flex;
  position: relative;
  margin-top: 0;

  .leftContainer {
    flex: 7;

  }

  .rightContainer {
    position: absolute;
    bottom: 20px;
    right: 0;
    flex: 1;
  }
}

/deep/.cell {
  padding: 0 3px !important;
}

.content {
  padding: 0 20px;

  /deep/.el-textarea__inner {
    height: 100px;
  }

  /deep/.el-radio {
    margin-bottom: 20px;
  }
}

a {
  color: #b4272d;

  &:hover {
    text-decoration: underline;
  }
}

/deep/.el-textarea__inner {
  height: 82px;
  padding: 5px;
}
</style>